// import moment from "moment";
// import dashboard from "../menu-items/dashboard";

// //dev api base url
// export const baseURL = "http://13.234.173.125:8081";


// //staging api base url
// //  export const baseURL =  "https://immunoact.hashstudioz.com";

// // uat api base url
// export const baseURL =  "https://cdm.immunoact.com";


// // Patient table data conversion
// export const convertSubjectData = (data) => {
//   return data?.map((sub) => {
//     let transformCode = sub?.subject_code;
//     let transformedSubjectInitial = sub?.sub_initials;
//     let transformeInvestigator = sub?.investigatorDetails?.name;
//     let transformedEditor = sub?.editorDetails?.name;
//     return [
//       transformCode,
//       transformedSubjectInitial,
//       transformeInvestigator,
//       transformedEditor,
//     ];
//   });
// };

// export const checkForSubchild = (firstSegment) => {
//   let isChild = null
//   for (let item of dashboard.children) {
//     if (item?.subChildren) {
//       for (let subItem of item.subChildren) {
//         if (subItem.id === firstSegment) {
//           isChild = subItem;
//           isChild.parent = item.title;
//           isChild.parentId = item.id;
//           break;
//         }
//       }
//     }
//   }
//   return isChild
// };




// function isDarkColor(color) {
//   const r = parseInt(color.substr(1, 2), 16);
//   const g = parseInt(color.substr(3, 2), 16);
//   const b = parseInt(color.substr(5, 2), 16);
//   const brightness = 0.299 * r + 0.587 * g + 0.114 * b;
//   return brightness < 128;
// }

// const usedColors = new Set();

// export function getRandomColor() {
//   const letters = "0123456789ABCDEF";
//   let color;

//   do {
//     color = "#";
//     for (let i = 0; i < 6; i++) {
//       color += letters[Math.floor(Math.random() * 16)];
//     }
//   } while (
//     isDarkColor(color) ||
//     color === "#000000" ||
//     color === "#00008B" ||
//     usedColors.has(color)
//   );

//   usedColors.add(color);
//   return color;
// }
// const formatDate = (dateString) => {
//   const [year, month, day] = dateString.split('-');
//   return `${day}/${month}/${year}`;
// };

// function capitalizeFirstLetter(str) {
//   if (!str) return "N/A"; // handle empty or undefined strings
//   return str.charAt(0).toUpperCase() + str.slice(1);
// }

// function formatDateMoment(date) {
//   if (!date || !moment(date).isValid()) {
//     return '-'; // Return 'N/A' if the date is invalid or missing
//   }
//   return moment(date).format('DD/MM/YYYY'); // Format the date to 'dd/mm/yyyy'
// }


// export const downloadCsv = (csvContent, filename) => {
//   const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
//   const url = URL.createObjectURL(blob);

//   // Create a link element, set the download attribute, and trigger a click event
//   const link = document.createElement('a');
//   link.href = url;
//   link.setAttribute('download', filename);
//   document.body.appendChild(link);
//   link.click();

//   // Clean up
//   document.body.removeChild(link);
//   URL.revokeObjectURL(url);
// };

// // @info handling other feilds on the export time.

// const getUserQuestions = (appointments) => {
//   const questions = [];
//   let questionCounter = 1; // Track question count

//   appointments.forEach((appointment) => {
//     appointment.reports.forEach((report) => {
//       if (report.answer && report.answer !== "") {
//         questions.push(`Question ${questionCounter++}`); // Assign unique question names
//       }
//     });
//   });

//   return questions; // Return array of unique column headers per user
// };

// export const jsonToCsv = (data) => {
//   const csvRows = [];

//   // Define static headers
//   const headers = [
//     'S.No.',
//     'Patient ID', 
//     'First Name', 
//     'Last Name',
//     'Patient Status',
//     'Status Change',
//     'Visit Type',
//     'Appointment Title'
//   ];

//   // Columns that should always be at the end
//   const endingHeaders = [
//     'Open Queries',
//     'Pending Approval',
//     'Approved',
//   ];

//   // Initialize serial number counter
//   let serialNumber = 1; 

//   // Process each user
//   data.forEach((item) => {
//     item.appointment.forEach((appointment) => {
//       // Extract only the questions this user has answered
//       const userQuestions = getUserQuestions([appointment]);

//       // If this is the first row, push the headers
//       if (csvRows.length === 0) {
//         csvRows.push([...headers, ...userQuestions, ...endingHeaders].map(header => `"${header}"`).join(','));
//       }

//       // Static data
//       const staticData = [
//         serialNumber++,
//         item.subject.patient_id || "-",
//         item.subject.first_name,
//         item.subject.last_name,
//         capitalizeFirstLetter(item.subject.life_status),
//         formatDateMoment(item.subject.status_change_date),
//         appointment.form_title,
//         appointment.title,
//       ];

//       // Assign answers dynamically based on their order
//       // let questionCounter = 1; // Track question number
//       const dynamicData = appointment.reports.map((report) => {
//         let answer = report?.answer || ''; 

//         if (typeof answer === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(answer)) {
//           answer = formatDate(answer);
//         }

//         if (Array.isArray(answer)) {
//           return `"${answer.filter(Boolean).join(', ')}"`; 
//         } else if (answer === null || answer === "") {
//           return ''; 
//         } else {
//           return `"${answer.replace(/\n/g, ' ')}"`; 
//         }
//       });

//       // Data for columns at the end
//       const endingData = [
//         appointment.query_raised?.length > 0 ? `"${appointment.query_raised.join(', ')}"` : 'N/A',
//         appointment.pending_users?.length > 0 ? `"${appointment.pending_users.join(', ')}"` : 'N/A',
//         appointment.approved_users?.length > 0 ? `"${appointment.approved_users.join(', ')}"` : 'N/A',
//       ];

//       // Push the row to CSV
//       csvRows.push([...staticData, ...dynamicData, ...endingData].join(','));
//     });
//   });

//   return csvRows.join('\n');
// };



// @info checking new one




import moment from "moment";
import dashboard from "../menu-items/dashboard";

//dev api base url
// export const baseURL =  "http://13.234.173.125:8081";


//staging api base url
//  export const baseURL =  "https://immunoact.hashstudioz.com";

// uat api base url
// export const baseURL =  "https://uat.immunoact.hashstudioz.com";


// Live api base url
// export const baseURL =  "https://cdm.immunoact.com";

//Live uat cdm base url
export const baseURL =  "https://cdmuat.immunoact.hashstudioz.us";
// Patient table data conversion
export const convertSubjectData = (data) => {
  return data?.map((sub) => {
    let transformCode = sub?.subject_code;
    let transformedSubjectInitial = sub?.sub_initials;
    let transformeInvestigator = sub?.investigatorDetails?.name;
    let transformedEditor = sub?.editorDetails
      ? `${sub.editorDetails.name}`
      : "Not Assigned";
    return [
      transformCode,
      transformedSubjectInitial,
      transformeInvestigator,
      transformedEditor,
    ];
  });
};

export const checkForSubchild = (firstSegment) => {
  let isChild = null
  for (let item of dashboard.children) {
    if (item?.subChildren) {
      for (let subItem of item.subChildren) {
        if (subItem.id === firstSegment) {
          isChild = subItem;
          isChild.parent = item.title;
          isChild.parentId = item.id;
          break;
        }
      }
    }
  }
  return isChild
};




function isDarkColor(color) {
  const r = parseInt(color.substr(1, 2), 16);
  const g = parseInt(color.substr(3, 2), 16);
  const b = parseInt(color.substr(5, 2), 16);
  const brightness = 0.299 * r + 0.587 * g + 0.114 * b;
  return brightness < 128;
}

const usedColors = new Set();

export function getRandomColor() {
  const letters = "0123456789ABCDEF";
  let color;

  do {
    color = "#";
    for (let i = 0; i < 6; i++) {
      color += letters[Math.floor(Math.random() * 16)];
    }
  } while (
    isDarkColor(color) ||
    color === "#000000" ||
    color === "#00008B" ||
    usedColors.has(color)
  );

  usedColors.add(color);
  return color;
}
const formatDate = (dateString) => {
  const [year, month, day] = dateString.split('-');
  return `${day}/${month}/${year}`;
};

function capitalizeFirstLetter(str) {
  if (!str) return "N/A"; // handle empty or undefined strings
  return str.charAt(0).toUpperCase() + str.slice(1);
}

function formatDateMoment(date) {
  if (!date || !moment(date).isValid()) {
    return '-'; // Return 'N/A' if the date is invalid or missing
  }
  return moment(date).format('DD/MM/YYYY'); // Format the date to 'dd/mm/yyyy'
}

// Helper function to strip HTML tags from text
const stripHtmlTags = (text) => {
  if (!text) return '';
  return text.replace(/<[^>]*>/g, '').trim();
};

// Helper function to group data by patient
const groupDataByPatient = (data) => {
  const groupedData = {};

  data.forEach((item) => {
    const patientKey = `${item.subject.patient_id}_${item.subject.first_name}_${item.subject.last_name}`;

    if (!groupedData[patientKey]) {
      groupedData[patientKey] = {
        subject: item.subject,
        appointments: []
      };
    }

    groupedData[patientKey].appointments.push(...item.appointment);
  });

  return Object.values(groupedData);
};


// Helper function to determine the highest approval status for a visit
const getDataReviewStatus = (approvedUsers) => {
  if (!approvedUsers || approvedUsers.length === 0) {
    return 'Data Entered';
  }

  const hasCPM = approvedUsers.some(user =>
    user.includes('Clinical Phase Manager')
  );
  if (hasCPM) {
    return 'Data Approved by CPM';
  }

  const hasDQA = approvedUsers.some(user =>
    user.includes('Quality Associate')
  );
  if (hasDQA) {
    return 'Data Approved by DQA';
  }

  const hasPI = approvedUsers.some(user =>
    user.includes('Principal Investigator')
  );
  if (hasPI) {
    return 'Data Approved by PI';
  }

  return 'Data Entered';
};

// Helper function to group appointments by visit type
const groupAppointmentsByVisitType = (appointments) => {
  const grouped = {};

  appointments.forEach((appointment) => {
    const visitType = appointment.form_title || 'Unknown';
    if (!grouped[visitType]) {
      grouped[visitType] = [];
    }
    grouped[visitType].push(appointment);
  });

  return grouped;
};

// Helper function to get questions by visit type
const getQuestionsByVisitType = (data) => {
  const questionsByVisit = {};

  data.forEach((item) => {
    item.appointment.forEach((appointment) => {
      const visitType = appointment.form_title || 'Unknown';
      if (!questionsByVisit[visitType]) {
        questionsByVisit[visitType] = new Set();
      }

      appointment.reports.forEach((report) => {
        questionsByVisit[visitType].add(stripHtmlTags(report.question));
      });
    });
  });

  Object.keys(questionsByVisit).forEach(visitType => {
    questionsByVisit[visitType] = Array.from(questionsByVisit[visitType]);
  });

  return questionsByVisit;
};

export const jsonToCsv = (data) => {
  const csvRows = [];

  const groupedData = groupDataByPatient(data);

  const staticHeaders = [
    'S.No.',
    'Patient ID',
    'First Name',
    'Last Name',
    'Patient Status',
    'Status Change'
  ];

  const allVisitTypes = new Set();
  data.forEach((item) => {
    item.appointment.forEach((appointment) => {
      if (appointment.form_title) {
        allVisitTypes.add(appointment.form_title);
      }
    });
  });
  const visitTypesArray = Array.from(allVisitTypes);

  const questionsByVisit = getQuestionsByVisitType(data);

  // Variable for For each visit type, add its questions + Data Review Status
  const dynamicHeaders = [];
  visitTypesArray.forEach(visitType => {
    const questions = questionsByVisit[visitType] || [];
    questions.forEach(question => {
      dynamicHeaders.push(question);
    });
    dynamicHeaders.push(`${visitType} - Data Review Status`);
  });

  const endingHeaders = [
    'Visit Types',
    'Appointment Titles',
    'Open Queries',
    'Pending Approval',
    'Approved',
  ];

  const allHeaders = [...staticHeaders, ...dynamicHeaders, ...endingHeaders];
  console.log('All Headers:', allHeaders);
  csvRows.push(allHeaders.map(header => `"${header}"`).join(','));

  let serialNumber = 1;

  // ForEach loop to Extract rows for one per patient
  groupedData.forEach((patientData) => {
    const staticData = [
      serialNumber++,
      patientData.subject.patient_id || "-",
      patientData.subject.first_name,
      patientData.subject.last_name,
      capitalizeFirstLetter(patientData.subject.life_status),
      formatDateMoment(patientData.subject.status_change_date)
    ];

    const appointmentsByVisit = groupAppointmentsByVisitType(patientData.appointments);

    const visitTypes = [];
    const appointmentTitles = [];
    const allQueries = [];
    const allPendingUsers = [];
    const allApprovedUsers = [];

    patientData.appointments.forEach((appointment) => {
      if (appointment.form_title) visitTypes.push(appointment.form_title);
      if (appointment.title) appointmentTitles.push(appointment.title);
      if (appointment.query_raised?.length > 0) allQueries.push(...appointment.query_raised);
      if (appointment.pending_users?.length > 0) allPendingUsers.push(...appointment.pending_users);
      if (appointment.approved_users?.length > 0) allApprovedUsers.push(...appointment.approved_users);
    });

    const dynamicData = [];
    
    visitTypesArray.forEach(visitType => {
      const questions = questionsByVisit[visitType] || [];
      const visitsOfType = appointmentsByVisit[visitType] || [];
      
      const answersForVisit = {};
      visitsOfType.forEach(appointment => {
        appointment.reports.forEach((report) => {
          const question = stripHtmlTags(report.question);
          let answer = report?.answer || '';

          // Conditional rendering to Format date answers
          if (typeof answer === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(answer)) {
            answer = formatDate(answer);
          }

          // Conditional rendering to Handle different answer types
          if (Array.isArray(answer)) {
            answer = answer.filter(Boolean).join(', ');
          } else if (answer === null || answer === "") {
            answer = '';
          } else {
            answer = String(answer).replace(/\n/g, ' ');
          }

          if (answer && answer.trim() !== '') {
            if (!answersForVisit[question]) {
              answersForVisit[question] = [];
            }
            answersForVisit[question].push(answer);
          }
        });
      });

      // FOrEach loop to Add answers for each question of this visit type
      questions.forEach(question => {
        const answers = answersForVisit[question] || [];
        const uniqueAnswers = [...new Set(answers)];
        dynamicData.push(uniqueAnswers.length > 0 ? `"${uniqueAnswers.join(' | ')}"` : '');
      });

      const allApprovedForVisit = [];
      visitsOfType.forEach(visit => {
        if (visit.approved_users?.length > 0) {
          allApprovedForVisit.push(...visit.approved_users);
        }
      });
      const status = getDataReviewStatus(allApprovedForVisit);
      dynamicData.push(`"${status}"`);
    });

    const endingData = [
      visitTypes.length > 0 ? `"${[...new Set(visitTypes)].join(' , ')}"` : 'N/A',
      appointmentTitles.length > 0 ? `"${[...new Set(appointmentTitles)].join(' , ')}"` : 'N/A',
      allQueries.length > 0 ? `"${[...new Set(allQueries)].join(' , ')}"` : 'N/A',
      allPendingUsers.length > 0 ? `"${[...new Set(allPendingUsers)].join(' , ')}"` : 'N/A',
      allApprovedUsers.length > 0 ? `"${[...new Set(allApprovedUsers)].join(' , ')}"` : 'N/A',
    ];

    csvRows.push([...staticData, ...dynamicData, ...endingData].join(','));
  });

  return csvRows.join('\n');
};


export const downloadCsv = (csvContent, filename) => {
  const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
  const url = URL.createObjectURL(blob);

  // Create a link element, set the download attribute, and trigger a click event
  const link = document.createElement('a');
  link.href = url;
  link.setAttribute('download', filename);
  document.body.appendChild(link);
  link.click();

  // Clean up
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
};